module.exports = __webpack_public_path__ + "static/illustration-sm1-18fba82c61ca874d8e3ca976240eb886.png";